import React, {useContext, useState, useEffect} from 'react';
import _ from "lodash";
import "./studentManagementForm.scss"
import {useHistory, withRouter} from "react-router-dom";
import {Formik, Form, Field, FieldArray} from "formik";
import { StoreContext } from '../../store/context'
import Paper from '@material-ui/core/Paper';
import { DatePicker } from "@material-ui/pickers";
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import FixedHeaderTable from '../../components/FixedHeaderTable';
import moment from 'moment';
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

const useStyles = makeStyles({
    table: {
        minWidth: 450,
    },
});


const columns = [
    { id: 'name', label: 'Student Name', minWidth: 170 },
    { id: 'programLvl', label: 'Program Level', minWidth: 110 },
    // {
    //     id: 'gender',
    //     label: 'Gender',
    //     minWidth: 170,
    //     align: 'right',
    // },
    {
        id: 'phoneNo',
        label: 'Phone No.',
        minWidth: 170,
        align: 'right',
    },
    // {
    //     id: 'icNo',
    //     label: 'NRIC No.',
    //     minWidth: 170,
    //     align: 'right',
    // },
    {
        id: 'subjectName',
        label: 'Subjects',
        minWidth: 200,
        align: 'right',
    },
    {
        id: 'status',
        label: 'Status',
        minWidth: 170,
        align: 'right',
        format: (value) => {
            if (value === "ACTIVE"){
                return (<span style={{color: "green", fontWeight:"bold"}}>{value}</span>)
            }
            return (<span style={{color: "red", fontWeight:"bold"}}>{value}</span>) },
    },
    {
        id: 'action',
        label: 'Action',
        minWidth: 170,
        align: 'right',
    },
];
//TODO   1 full name list with subjects (IC & No of subject hide )
//     2 select terminate date
//     3 select add on subjects enroll date
const StudentManagementList = () => {
    const classes = useStyles();
    const history = useHistory();
    const { state, actions } = useContext(StoreContext); // get global state and dispatch function
    const { setFormData } = actions.formActions; // export setFormData function
    const { getAllStudents, getAllTeachers, getAllTuitionFees, getAllMisc, getSingleStudentInfoByUuid } = actions.generalActions;
    const { getStudentPayments, getSingleStudentPaymentDetail, showStudentDetailDialog, submitStudentPaymentDetail } = actions.paymentActions;
    const { studentPayment, studentPaymentDetail, studentDetailDialogVisible } = state.paymentStates;
    const { students } = state.generalStates;
    const [selectedDate, handleDateChange] = useState(new Date());
    useEffect(() => {
        getAllStudents();
        getAllTeachers();
        getAllTuitionFees();
        getAllMisc();
        // getStudentPayments(moment().get('month')+1);
        const month = moment(selectedDate).format('MM-YYYY');
        getStudentPayments(month);
    }, []);

    const [programLvl, setProgramLvl] = React.useState(null);
    const [studentName, setStudentName] = React.useState(null);

    const handleChange = (event) => {
        setProgramLvl(event.target.value);
    };

    const handleStudentNameChange = (event) => {
        setStudentName(event.target.value);
    };

    const onViewDetailClick = (uuid) => {
        setFormData({studentRegistration : {
                uuid: uuid
            }});
        getSingleStudentInfoByUuid(history, uuid);
    };

    const handleClose = () => {
        showStudentDetailDialog(false);
    };

    const handlePayNow = () => {
        submitStudentPaymentDetail(studentPaymentDetail);
        showStudentDetailDialog(false);
    };

    const handleSearchButton = () => {
        getAllStudents(studentName, programLvl);
    };

    const renderStudentDetails = () => {
        let totalFee = 0;
        for (let i = 0; i < studentPaymentDetail.length; i++){
            if (studentPaymentDetail[i].paymentStatus === "PAID") {
                totalFee += studentPaymentDetail[i].fee;
            }
        }

        const  courseDetails  = (
            <TableContainer component={Paper} style={{marginTop: "10px"}}>
                <Table className={classes.table} aria-label="spanning table">
                    <TableHead>
                        <TableRow>
                            <TableCell
                                style={{ background: "#3f51b5", color: "white" }}
                                align="left">Subject Name.</TableCell>
                            <TableCell
                                style={{ background: "#3f51b5", color: "white" }}
                                align="left">Paid</TableCell>
                            <TableCell
                                style={{ background: "#3f51b5", color: "white" }}
                                align="right">Fee</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {studentPaymentDetail.map((row) => (
                            <TableRow key={row.subjectName}>
                                <TableCell>{row.subjectName}</TableCell>
                                <TableCell>{row.paymentStatus}</TableCell>
                                <TableCell align="right">{row.fee}</TableCell>
                            </TableRow>
                        ))}

                        <TableRow>
                            <TableCell rowSpan={3} />
                            <TableCell colSpan={1}><b>Total</b></TableCell>
                            <TableCell align="right"><b>{totalFee}</b></TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        )
                // <div>
                //     <TextField margin="dense" label="Nric No."
                //                value={obj.subject} fullWidth disabled
                //     />
                //     <TextField margin="dense" label="Nric No."
                //                value={obj.fee} fullWidth disabled
                //     />
                // </div>
        if (studentPaymentDetail.length> 0) {
            return (
                <div>
                    <TextField margin="dense" label="Name"
                               value={studentPaymentDetail[0].name} fullWidth disabled
                    />
                    <TextField margin="dense" label="Program Level"
                               value={studentPaymentDetail[0].programLvl} fullWidth disabled
                    />
                    <TextField margin="dense" label="Nric No."
                               value={studentPaymentDetail[0].icNo} fullWidth disabled
                    />
                    {courseDetails}
                </div>
            )
        }
    };





    return (
        <div className="student-management-container">
            <h1 className="header">Student Management</h1>
            <div className="paperContainer">
                <FormControl className="form-control">
                    <InputLabel id="program-lvl-label">Program level</InputLabel>
                    <Select
                        labelId="program-lvl-label"
                        value={programLvl}
                        onChange={handleChange}
                    >
                        <MenuItem value={1}>Remove</MenuItem>
                        <MenuItem value={2}>Form 1</MenuItem>
                        <MenuItem value={3}>Form 2</MenuItem>
                        <MenuItem value={4}>Form 3</MenuItem>
                        <MenuItem value={5}>Form 4</MenuItem>
                        <MenuItem value={6}>Form 5</MenuItem>
                        <MenuItem value={8}>Form 5 (Graduated)</MenuItem>
                    </Select>
                </FormControl>

                <TextField className="text-field" label="Student name" onChange={handleStudentNameChange}/>

                <Button className="search-btn" variant="contained" color="primary" onClick={handleSearchButton}>
                    Search
                </Button>
            </div>
            <div className="table-container">
                {students && <FixedHeaderTable columns={columns} rows={students} buttonContent="View Details" buttonAction={onViewDetailClick}/>}
            </div>
        </div>
    )
}

export default withRouter(StudentManagementList)
